module.exports = __webpack_public_path__ + "static/PsychedelicSimulator-1ba9a0d7ecd2cf4cb1ef87acc9404a05.gif";